<template>
    <div class="form-group row inline-form" v-bind:class="{ 'has-danger' : form.errors.has(name_1) }">
        <label class="col-md-3 col-xl-2 col-12 col-form-label" :for="name_1">{{ label }}: </label>
        <div class="col-md-9 col-xl-10 col-12">
            <div class="row">
                <div class="col-md-6">
                    <vue-pikaday
                            v-model="form[name_1]"
                            :options="options"
                            :required="required"
                            :placeholder="placeholder_1"
                            class="form-control"
                            autocomplete="off"
                    />
                    <span class="help-block form-control-feedback" v-if="form.errors.has(name_1)" v-text="form.errors.get(name_1)"></span>
                </div>
                <div class="col-md-6 ">
                    <vue-pikaday
                            v-model="form[name_2]"
                            :options="options"
                            :required="required"
                            :placeholder="placeholder_2"
                            class="form-control"
                            autocomplete="off"
                    />
                    <span class="help-block form-control-feedback" v-if="form.errors.has(name_2)" v-text="form.errors.get(name_2)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { PikadayOptions } from "~/Form/elements";

    export default {
        name: "form-daterange-picker",

        props: {
            form: {
                required: true
            },
            name_1: {
                required: true,
                type: String
            },
            name_2: {
                required: true,
                type: String
            },
            placeholder_1: {
                default: config.date_format_trans
            },
            placeholder_2: {
                default: config.date_format_trans
            },
            label: {},
            required: {
                type: Boolean,
                default: false,
            }
        },

        data(){
            return {
                options: PikadayOptions,
            };
        },
    }
</script>

<style scoped>
</style>
